export default __webpack_public_path__ + "static/media/dec2024-5.bc4d626f.jpeg";